import React, { useState } from "react";
import { connect } from "react-redux";
import { increaseViewCount, getCookie } from "../../../Common/CommonMethods";
import CaseStudyPopup from "../../../Common/Popups/CaseStudiesPopup";
import LeadGen from "../../../Common/Popups/LeadGen";
import ImageLoader from "../../../Common/ImageLoader";

import { openAPI } from "../../../../config";

const fallbackPhoto = "/images/avatar.webp";
const VendorCaseStudy = (props) => {
  const [isLeadGenPopUp, setLeadGenPopUp] = useState(false);
  const [isEntered, setIsEntered] = useState(false);
  const [vendorCaseStudy, setVendorCaseStudy] = useState({
    activeVideoPopUp: {
      isPopUpActive: false,
    },
    ...props,
  });

  const handleExitUrl = (exit_url) => {
    openAPI
      .put(
        `${process.env.REACT_APP_API_URL}${exit_url.replace("/api/v1", "")}`,
        {},
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": `${getCookie("fc_react_csrfmiddlewaretoken")}`,
          },
        }
      )
      .then((response) => {
        if (!!response.data.exit_url) {
          openInNewTab(response.data.exit_url);
        }
      })
      .catch((error) => {});
  };

  const setPopUpFalse = (location) => {
    const tempObj = {
      ...vendorCaseStudy,
      ...location,
      activeVideoPopUp: {
        isPopUpActive: false,
      },
    };
    setVendorCaseStudy(tempObj);
    setIsEntered(false);
  };

  const openInNewTab = (href) => {
    Object.assign(document.createElement("a"), {
      target: "_blank",
      href,
    }).click();
  };

  const postLeadRegPopUp = (isEnterpriseLoginStatus) => {
    if (!isEnterpriseLoginStatus) {
      setVendorCaseStudy({
        ...vendorCaseStudy,
        activeVideoPopUp: {
          isPopUpActive: true,
        },
        toLocation: props.pathname,
      });
      handleExitUrl(vendorCaseStudy.exit_url);
    }
  };

  return (
    <React.Fragment>
      <li
        onClick={(e) => {
          e.preventDefault();
          if (props.pathname.includes("/premium/preview")) {
            return;
          }
          setIsEntered(false);
          if (props.isLeadGenPopUp) {
            setLeadGenPopUp(true);
          } else {
            if (!props.isEnterpriseLogin) {
              handleExitUrl(vendorCaseStudy.exit_url);
              setVendorCaseStudy({
                ...vendorCaseStudy,
                activeVideoPopUp: {
                  isPopUpActive: true,
                },
                toLocation: props.pathname,
              });
            }
          }
        }}
      >
        <h4>
          <span>{props.title}</span>
        </h4>
        <div className="footer_bottom footer_bottom_case_study">
          {Object.keys(props.contactdetail).length > 0 ? (
            <div className="user_details">
              <span className="name">{props.contactdetail.name}</span>
              <span className="desgn">{props.contactdetail.jobtitle}</span>
            </div>
          ) : null}
          <div class="case_study_logo">
            <ImageLoader
              image={props.customer_logo}
              fallbackImage={"/images/evo_img.webp"}
            />
          </div>
        </div>

        {vendorCaseStudy.activeVideoPopUp &&
        vendorCaseStudy.activeVideoPopUp.isPopUpActive ? (
          <CaseStudyPopup
            caseStudyDataForPopUp={vendorCaseStudy}
            isDataFromProps={true}
            setPopUpFalse={setPopUpFalse}
          />
        ) : null}
        {isLeadGenPopUp ? (
          <LeadGen
            {...props}
            setLeadGenPopUp={setLeadGenPopUp}
            postLeadRegPopUp={postLeadRegPopUp(props.isEnterpriseLogin)}
            pathname={props.pathname.replace("/case-studies", "")}
            linkedInUrl={props.linkedInUrl}
          />
        ) : null}
      </li>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isEnterpriseLogin: state.homePage.isEnterpriseLogin,
  };
};
export default connect(mapStateToProps)(VendorCaseStudy);
